import { useFetchQuotationUserRfqReviewsQuery } from '@generated/graphql';
import { useSelector } from '@store';
import React, { useState } from 'react';
import WrittenReviewPresenter from './WrittenReviewPresenter';

const WrittenReviewContainer = () => {
  const id = useSelector((state) => state.client.id);
  const [visibleCount, setVisibleCount] = useState(4);

  const { data, loading } = useFetchQuotationUserRfqReviewsQuery({
    variables: {
      input: {
        quotationUserId: id
      }
    },
    skip: !id
  });

  const writtenReviews = data?.fetchQuotationUserRfqReviews.data ?? [];

  const maxVisibleCount = writtenReviews.length;

  const handleVisibleCount = () => {
    return setVisibleCount((prev) => {
      if (prev + 4 >= maxVisibleCount) {
        return maxVisibleCount;
      }

      return prev + 4;
    });
  };

  return (
    <WrittenReviewPresenter
      writtenReviews={writtenReviews.slice(0, visibleCount)}
      loading={loading}
      invisibleMoreButton={
        visibleCount === maxVisibleCount || writtenReviews.length < 5
      }
      handleVisibleCount={handleVisibleCount}
    />
  );
};

export default WrittenReviewContainer;
